import { AnimatedCircularProgressBar } from '@talentmesh/ui/components/animated-circular-progress-bar';
import { cn } from '@talentmesh/ui/lib/utils';
import { PercentileLevel } from '@talentmesh/utils';

import LeftPetal from './LeftPetal';
import RightPetal from './RightPetal';

export interface ScoreItem {
    value: number;
    level: PercentileLevel;
    name: string;
}
export interface ChamomileProps {
    overall: ScoreItem;
    scores: ScoreItem[];
}

export function Chamomile({ overall, scores }: ChamomileProps) {
    const { length } = scores;
    const size = Math.round(length / 2);
    const justifyContentLeft = `${length === 1 || length === 2 ? 'center' : 'space-between'}`;
    const justifyContentRight = `${length === 2 || length === 3 ? 'center' : 'space-between'}`;

    return (
        <div className="flex flex-row items-center justify-center">
            <div
                className={cn(
                    'flex h-70 w-100 flex-col gap-4',
                    justifyContentLeft === 'center' ? 'justify-center' : 'justify-between',
                )}
            >
                {scores.slice(0, size).map((score, index, array) => (
                    <LeftPetal key={score.name} {...score} index={index} count={array.length} />
                ))}
            </div>
            <div className="px-4">
                <AnimatedCircularProgressBar
                    value={overall.value}
                    level={overall.level}
                    text={overall.name}
                    className="text-foreground size-50"
                />
            </div>
            <div
                className={cn(
                    'flex h-70 w-100 flex-col gap-4',
                    justifyContentRight === 'center' ? 'justify-center' : 'justify-between',
                )}
            >
                {scores.slice(size, length).map((score, index, array) => (
                    <RightPetal key={score.name} {...score} index={index} count={array.length} />
                ))}
            </div>
        </div>
    );
}
